export type BillingCycle = 'monthly' | 'yearly';
export type PlanCode = 'free' | 'standard' | 'pro' | 'experto';

export type PlanDefinition = {
  code: PlanCode;
  name: string;
  priceMonthly: number;
  priceYearly: number;
  priceMonthlyEUR?: number;
  priceYearlyEUR?: number;
  features: string[];
  isFree?: boolean;
};

export const PLAN_CATALOG: PlanDefinition[] = [
  {
    code: 'free',
    name: 'Free',
    priceMonthly: 0,
    priceYearly: 0,
    isFree: true,
    features: [
      '1 análisis IA por sesión',
      'Predicciones básicas',
      'Acceso a 2 ligas principales',
      'Soporte por email',
    ],
  },
  {
    code: 'standard',
    name: 'Standard',
    priceMonthly: 21900,
    priceYearly: 210000,
    priceMonthlyEUR: 4.99,
    priceYearlyEUR: 49.99,
    features: [
      '12 análisis IA por sesión',
      'Predicciones mejoradas',
      'Acceso a 8 ligas principales',
      'AI Insights básicos',
      'Soporte prioritario',
    ],
  },
  {
    code: 'pro',
    name: 'Pro',
    priceMonthly: 34900,
    priceYearly: 335000,
    priceMonthlyEUR: 6.99,
    priceYearlyEUR: 69.99,
    features: [
      '20 análisis IA por sesión',
      'Value picks destacados',
      'Acceso a todas las ligas',
      'AI Insights avanzados',
      'Soporte prioritario',
    ],
  },
  {
    code: 'experto',
    name: 'Experto',
    priceMonthly: 49900,
    priceYearly: 479000,
    priceMonthlyEUR: 9.99,
    priceYearlyEUR: 99.99,
    features: [
      'Análisis IA ilimitados',
      'Todas las predicciones',
      'AI Insights premium',
      'Análisis personalizados',
      'Soporte 24/7',
      'Acceso anticipado',
    ],
  },
];

export const PLAN_MAP = PLAN_CATALOG.reduce<Record<PlanCode, PlanDefinition>>((acc, plan) => {
  acc[plan.code] = plan;
  return acc;
}, {} as Record<PlanCode, PlanDefinition>);
